export var UoUStatuses = [
    'Void',
    'Paid',
    'Overdue',
    'PartiallyPaid',
    'PartialAndOverdue',
];
export var isStatusDisplayed = function (_a) {
    var status = _a.status, isUoU = _a.isUoU;
    return !isUoU || UoUStatuses.includes(status);
};
//# sourceMappingURL=status-utils.js.map